import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, GridRequestDto, OwnerCheckingAccountMovementsResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetOwnerCheckingAccountMovementsCommand extends IRequestCommand<
  IGetOwnerCheckingAccountMovementsResponse,
  ErrorDetails,
  IGetOwnerCheckingAccountMovementsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/vehicleOwners/{driverUserId}/checkingAccountMovements/paginated?page={page}&size={size}&column={column}&sort={sort}&find={find}';

  public override setParameters(
    parameters: IGetOwnerCheckingAccountMovementsCommandParameters
  ) {
    this.urlSections.push('carriers');
    this.urlSections.push(`${parameters.carrierUserId.toString()}`);
    this.urlSections.push('vehicleOwners');
    this.urlSections.push(`${parameters.id.toString()}`);
    this.urlSections.push('checkingAccountMovements');
    this.urlSections.push('paginated');
    if (!!parameters.page) {
      this.paramsSections.push(`page=${parameters.page}`);
    }
    if (!!parameters.size) {
      this.paramsSections.push(`size=${parameters.size}`);
    }
    if (!!parameters.column) {
      this.paramsSections.push(`column=${parameters.column}`);
    }
    if (!!parameters.sort) {
      this.paramsSections.push(`sort=${parameters.sort}`);
    }
    if (!!parameters.startDate) {
      this.paramsSections.push(
        `startDate=${parameters.startDate.toISOString().split('T')[0]}`
      );
    }
    if (!!parameters.endDate) {
      this.paramsSections.push(
        `endDate=${parameters.endDate.toISOString().split('T')[0]}`
      );
    }
    if (!!parameters.find) {
      this.paramsSections.push(`find=${parameters.find}`);
    }
    if (!!parameters.movementFilter) {
      this.paramsSections.push(`movementFilter=${parameters.movementFilter}`);
    }
    this.composeUrl();
  }
}

export interface IGetOwnerCheckingAccountMovementsCommandParameters
  extends ICommandParameters,
    GridRequestDto {
  id: number;
  startDate: Date;
  endDate: Date;
  movementFilter?: string;
}

export interface IGetOwnerCheckingAccountMovementsResponse
  extends OwnerCheckingAccountMovementsResponseDTO,
    ICommandResponse {}
